<template>
  <user-picker
    :value="objects"
    :title="title"
    type="partners"
    :multiple="multiple"
    :disabled="disabled"
    :height="40"
    class="cup"
    @input="onInput"
  />
</template>

<script>
// Assignee / user picker for the CRM. Uses the same people source as the task
// desk (SettingAccountPicker, `getdetail?select=partners`) so CRM owners are
// the same users as task functors. v-model is a users.id (or an array of
// ids); names are cached in crm.users so cards and tables can show them.
import UserPicker from '../../setting/components/SettingAccountPicker'
import { crm, memberName, rememberUser } from '../crmStore'

export default {
  name: 'CrmUserPicker',
  components: { UserPicker },
  props: {
    value: { type: [Number, String, Array], default: null },
    title: { type: String, default: 'crmOwner' },
    multiple: Boolean,
    disabled: Boolean
  },
  computed: {
    objects () {
      const toObj = id => (id && typeof id === 'object') ? id : (id ? { id, name: crm.users[id] || memberName(id) } : null)
      if (this.multiple) return (this.value || []).map(toObj).filter(Boolean)
      return toObj(this.value)
    }
  },
  methods: {
    onInput (v) {
      const list = Array.isArray(v) ? v : (v ? [v] : [])
      list.forEach(o => o && rememberUser(o.id, o.name))
      if (this.multiple) this.$emit('input', list.map(o => o.id))
      else this.$emit('input', v ? v.id : null)
      this.$emit('change')
    }
  }
}
</script>
